var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.iCan("view", "Orders")
    ? _c(
        "span",
        [
          _vm.scopeorder
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    "max-width": "1700px",
                    scrollable: "",
                    persistent: ""
                  },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "bb-1" },
                        [
                          _c("span", { staticClass: "headline" }, [
                            _vm._v(
                              _vm._s(_vm.viewform ? "View" : "New") +
                                " " +
                                _vm._s(
                                  _vm.type === "purchase-order"
                                    ? "Purchase Order"
                                    : "Order"
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.iCan("view", "Exports") &&
                          _vm.myexports.length &&
                          _vm.viewform
                            ? _c("order-exports", {
                                attrs: {
                                  type: _vm.type,
                                  customer: _vm.customer,
                                  keyedFieldValues: _vm.keyedFieldvalues,
                                  order: _vm.order
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.viewform
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: { click: _vm.toggleLog }
                                },
                                [_c("v-icon", [_vm._v("mdi-history")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.editDisabled && _vm.scopeorder.configuration
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    bottom: "",
                                    left: "",
                                    "close-on-content-click": false
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                { attrs: { icon: "" } },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("more_vert")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3491234933
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-switch", {
                                            staticClass: "mt-0",
                                            attrs: {
                                              label: "Field Assignments",
                                              "input-value":
                                                _vm.scopeorder.configuration
                                                  .fieldassignments,
                                              "hide-details": ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.switchAssignments(
                                                  "fields"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-switch", {
                                            attrs: {
                                              label: "Price Assignments",
                                              "input-value":
                                                _vm.scopeorder.configuration
                                                  .priceassignments,
                                              "hide-details": ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.switchAssignments(
                                                  "prices"
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-form",
                            { key: _vm.scopeorder.id, ref: "orderform" },
                            [
                              _vm.orderFieldsTop.length
                                ? _c(
                                    "v-card-text",
                                    { staticClass: "transparent-darken-1" },
                                    [
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            "grid-list-lg": "",
                                            "pa-0": ""
                                          }
                                        },
                                        [
                                          _c("field-form", {
                                            ref: "fieldformtop",
                                            attrs: {
                                              assignment_type: _vm.type,
                                              assignment_id: _vm.scopeorder.id,
                                              availableassignments:
                                                _vm.availableassignments,
                                              columns: _vm.columns,
                                              fields: _vm.orderFieldsTop,
                                              keyedFieldvalues:
                                                _vm.keyedFieldvalues,
                                              overrides: _vm.overrides,
                                              setDefault: !_vm.viewform,
                                              viewform: _vm.viewform,
                                              inlineEdit: _vm.viewform,
                                              inlineSave: _vm.inlineSave,
                                              editDisabled: _vm.editDisabled
                                            },
                                            on: {
                                              inputChanged: _vm.OrderChanged
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-data-table",
                                {
                                  class: {
                                    "bt-1": _vm.orderFieldsTop.length,
                                    "bb-1": _vm.orderFieldsBottom.length
                                  },
                                  attrs: {
                                    "hide-default-footer": "",
                                    items: _vm.scopeorder.orderitems,
                                    "items-per-page": -1,
                                    headers: _vm.rowHeaders
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item",
                                        fn: function(props) {
                                          return _c("order-row", {
                                            key: props.item.id,
                                            ref: "orderrow" + props.index,
                                            attrs: {
                                              type: _vm.type,
                                              availableassignments:
                                                _vm.availableassignments,
                                              customerField: _vm.customerField,
                                              department: _vm.department,
                                              editing:
                                                _vm.viewform &&
                                                props.item.id &&
                                                _vm.editingRows.indexOf(
                                                  props.item.id
                                                ) < 0
                                                  ? false
                                                  : true,
                                              editDisabled: _vm.editDisabled,
                                              fields: _vm.orderitemFields,
                                              highlight:
                                                props.item.id &&
                                                _vm.department &&
                                                _vm.department.id &&
                                                _vm.scopeorder.configuration[
                                                  "h" + _vm.department.id
                                                ].indexOf(props.item.id) > -1,
                                              keyedFieldvalues:
                                                _vm.keyedFieldvalues,
                                              order_id: _vm.scopeorder.id,
                                              overrides: _vm.overrides,
                                              priceOverrides:
                                                _vm.priceOverrides,
                                              productField: _vm.productField,
                                              row: props.item,
                                              rowindex: props.index,
                                              setprices:
                                                _vm.scopeorder.configuration
                                                  .priceassignments,
                                              viewform: _vm.viewform,
                                              inlineSave: _vm.inlineSave,
                                              canEditItems: _vm.canEditItems,
                                              assignment_type: _vm.type
                                            },
                                            on: {
                                              deleteOrderitem:
                                                _vm.deleteOrderitem,
                                              OrderChanged: _vm.OrderChanged,
                                              priceChanged: _vm.priceChanged,
                                              pricetypeChanged:
                                                _vm.pricetypeChanged,
                                              setEdit: _vm.setEdit,
                                              totalChanged: _vm.totalChanged,
                                              highlightItem: _vm.highlightItem
                                            }
                                          })
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2782764341
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.priceOverrides.total.visibility ===
                                    "visible" &&
                                  _vm.scopeorder.orderitems.length > 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "os-order-footer",
                                          class: { editing: _vm.editing },
                                          attrs: { slot: "footer" },
                                          slot: "footer"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "px-2" },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Total",
                                                  prefix: "£",
                                                  readonly: "",
                                                  value: _vm._f("price")(
                                                    _vm.totalPrice
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.orderFieldsBottom.length
                                ? _c(
                                    "v-card-text",
                                    { staticClass: "transparent-darken-1" },
                                    [
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            "grid-list-lg": "",
                                            "pa-0": ""
                                          }
                                        },
                                        [
                                          _c("field-form", {
                                            ref: "fieldformbottom",
                                            attrs: {
                                              assignment_type: _vm.type,
                                              assignment_id: _vm.scopeorder.id,
                                              availableassignments:
                                                _vm.availableassignments,
                                              columns: _vm.columns,
                                              fields: _vm.orderFieldsBottom,
                                              keyedFieldvalues:
                                                _vm.keyedFieldvalues,
                                              overrides: _vm.overrides,
                                              setDefault: !_vm.viewform,
                                              viewform: _vm.viewform,
                                              inlineEdit: _vm.viewform,
                                              inlineSave: _vm.inlineSave,
                                              editDisabled: _vm.editDisabled
                                            },
                                            on: {
                                              inputChanged: _vm.OrderChanged
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "bt-1 fixed-actions" },
                        [
                          _vm.iCan("delete", "Orders") &&
                          _vm.viewform &&
                          _vm.canDeleteOrder
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "error",
                                    dark: _vm.darks.error,
                                    light: !_vm.darks.error
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.deleteOrder()
                                    }
                                  }
                                },
                                [
                                  _vm._v("\n\t\t\t\t\t\tDelete\n\t\t\t\t\t\t"),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: "",
                                        dark: _vm.darks.error,
                                        light: !_vm.darks.error
                                      }
                                    },
                                    [_vm._v("mdi-delete-outline")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.editDisabled && _vm.canEditItems
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    dark: _vm.darks.success,
                                    light: !_vm.darks.success
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.addOrderitem()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\tProduct row\n\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: "",
                                        dark: _vm.darks.success,
                                        light: !_vm.darks.success
                                      }
                                    },
                                    [_vm._v("mdi-plus-circle-outline")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.state.processing,
                                text: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.closeOrder()
                                }
                              }
                            },
                            [_vm._v("Close")]
                          ),
                          _vm._v(" "),
                          !_vm.viewform || !_vm.inlineSave
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "success",
                                    dark: _vm.darks.success,
                                    light: !_vm.darks.success
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.saveOrder()
                                    }
                                  }
                                },
                                [
                                  _vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t\t\t"),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: "",
                                        dark: _vm.darks.success,
                                        light: !_vm.darks.success
                                      }
                                    },
                                    [_vm._v("mdi-check-outline")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.showLog,
                callback: function($$v) {
                  _vm.showLog = $$v
                },
                expression: "showLog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "bb-1" }, [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Order history")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-simple-table", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c(
                                "tbody",
                                _vm._l(_vm.order.logs, function(log) {
                                  return _c("tr", { key: log.time }, [
                                    _c("td", [_vm._v(_vm._s(log.user))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(log.action))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("datetime")(log.created_at)
                                        )
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      405098536
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "bt-1 fixed-actions" },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { text: "" }, on: { click: _vm.toggleLog } },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d859cee0", { render: render, staticRenderFns: staticRenderFns })
  }
}